import { Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { IFundraiser } from '../../fundraiser/models/fundraiser.model';
import { EventsService, UtilService, VariablesService, VwoService } from '../../shared/services';

@Component({
  selector: 'app-ended-fundraiser-sip-dialog',
  templateUrl: './ended-fundraiser-sip-dialog.component.html',
  styleUrls: ['./ended-fundraiser-sip-dialog.component.scss']
})
export class EndedFundraiserSipDialogComponent implements OnChanges, OnInit, OnDestroy {

  @Input() fundraiser: IFundraiser;
  @Input() currency;
  supporterImg;
  closePopupVar = 'flex';
  onLoadFundraiser;
  userData;
  isSipSubscribed;

  constructor(
    public util: UtilService,
    private events: EventsService,
    public vwo: VwoService,
    private vars: VariablesService
  ) { }


  ngOnChanges() {
    this.onLoadFundraiser = this.fundraiser;
  }

  ngOnInit() {
    this.vars.userData.subscribe({
      next: (res) => {
        this.userData = res;
        if (res) {
          this.checkSipType();
        }
      }
    });
    this.supporterImg = `${environment.APP.IMAGE_DOMAIN}/images/random_supporters/${Math.floor(Math.random() * 10) + 1}.png`;
    this.events.sendSystemEvent({
      eventName: 'ended_fundraiser_sip_popup',
      page_name: this.vars.pageName,
      info_3: 'impact'
    }).subscribe(_ => _);
    this.setBodyClass('hidden');
  }

  closePopup() {
    this.vars.fundraiser = this.onLoadFundraiser;
    this.closePopupVar = 'none';
    this.setBodyClass('');
    this.events.sendSystemEvent({
      eventName: 'continue_to_fundraiser',
      page_name: this.vars.pageName,
      info_3: 'impact'
    }).subscribe(_ => _);
  }

  setBodyClass(value) {
    if (typeof document !== 'undefined') {
      document.body.style.overflow = value;
      this.util.scrollToTop();
    }
  }

  checkSipType() {
    const sip_status_flag = this.util.checkForActiveSip(this.userData?.listsubscriptions);
    if (sip_status_flag.toString().match('1|2')) {
      this.isSipSubscribed = true;
    }
  }


  ngOnDestroy() {
    this.setBodyClass('');
  }

}
